import { render, staticRenderFns } from "./openclassbofang.vue?vue&type=template&id=c0f6b3d2&scoped=true"
import script from "./openclassbofang.vue?vue&type=script&lang=js"
export * from "./openclassbofang.vue?vue&type=script&lang=js"
import style0 from "./openclassbofang.vue?vue&type=style&index=0&id=c0f6b3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f6b3d2",
  null
  
)

export default component.exports